/**
 * 指導管理ページ用のスクリプト
 */
 if (is_route('guidance_kind.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        guidance_kind_event_set();
        guidance_kind_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.guidance_kind_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });
}
/**
 * 設定時のイベント設定
 */
window.guidance_kind_setting_event_set = function() {

    /*---- 指導種別切り替え時 ----*/

    $(document).on('change', '#guidance_kind-setting-modal input[name=guidance_type]', function() {
        const show = $(this).data('general-guidance-type') == $(this).val();
        $('.general-guidance-inputs').toggleClass('display-none', !show);
    });

    /*---- 指導方法切り替え時 ----*/

    $(document).on('change', '#guidance_kind-setting-modal input[name=method_type]', function() {
        const show = $(this).data('repeat-method-type') == $(this).val();
        $('.repetition-inputs').toggleClass('display-none', !show);
    });

}
